export class Relatorio {
    idOrganizacao: number;
    nome: string;
    email: string;
    ativo: boolean;
    excluido: boolean;
    pendente: boolean;
    dataInicio: string;
    dataFim: string;    
    numeroPedido: number;
    idCertificadoComunicacao: number;
}